// Hook to determine when we switch to mobile view

import { useWindowSize } from 'usehooks-ts'
import {isMobile} from 'react-device-detect'

export function useIsMobile() {
    const { width, height } = useWindowSize()
    const isNarrow = (width <= 647)
    return isMobile || isNarrow
}